module.exports = __webpack_public_path__ + "static/img/plat.283b31e4.png";